export default __webpack_public_path__ + "static/media/mediaTypeDigitalOOH.7efff568.svg";